import Marquee from "react-fast-marquee";
import skillData from "../data/skillData"; // skillData 가져오기

export default function MultipleMarquee() {
  return (
    <div className="flex flex-col gap-5 overflow-hidden w-full py-20">
      <Marquee direction="left" speed={30}>
        {skillData.map((item, index) => (
          <img
            key={index}
            src={`assets/images/skill/${item.image}`}
            alt={`left-${index}`}
            className="h-[50px] mx-10 object-cover my-10 rounded-lg"
          />
        ))}
      </Marquee>
    </div>
  );
}
